import {TOGGLE_LOADER} from '../actions/types';

const initialState = {
  loader: false,
};

const loaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_LOADER:
      return Object.assign({}, state, {
        loader: action.payload,
      });
    default:
      return state;
  }
};

export default loaderReducer;
